define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/store/Values",
	"csi/table/NewFrom",
	"csi/xml"
], function(declare,lang,ValuesStore,NewFrom,xml) {

	return declare(NewFrom, {
		getFormData: function() {
			// summary: add hook into form data to determine if the Shape SizeChartDimension node is already selected
			var fd = this.inherited(arguments);
			fd.m_fAggregateSelected = lang.hitch(this, this._isPreSelected);
			return fd;
		},

		_isPreSelected: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: determine if SysID has already in the existing SizeChartDimension.ShapeSysID
			return !!this._shapeSysIDStore.get(ctx.getNode().SysID);
		},

		_preAction: function() {
			// summary: add any requests necessary to fetch data before executing action
			this._shapeSysIDStore = new ValuesStore({
				typeNode: "SizeChartDimension",
				requestParameters: {
					"Qry.Limit.Path": xml.getUrlPath(this.getParentURL(), xml.path("Items")),
					"Qry.Value.Attr": "ShapeSysID"
				}
			});

			return this._shapeSysIDStore.query();
		}
	});
});